<script setup>
import { useFileDialog, useImage } from '@vueuse/core';
import { computed, ref } from 'vue';

const emit = defineEmits(['image-loaded', 'image-changed']);

const inputImageSrc = ref('');
const inputImageOptions = computed(() => ({
  src: inputImageSrc.value,
}));

const { state: inputImage } = useImage(inputImageOptions, {
  onSuccess(image) {
    emit('image-loaded', image);
  },
});

const { open, onChange: onInputChange } = useFileDialog({
  accept: 'image/*',
  multiple: false,
});

onInputChange(async files => {
  if (!files) return;
  inputImageSrc.value = URL.createObjectURL(files[0]);
  emit('image-changed', files[0]);
});
</script>

<template>
  <button
    class="virtual-photo-booth__button virtual-photo-booth__button-file-dialog"
    type="button"
    @click="open"
  >
    <slot />
  </button>
</template>
